import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-it-facility-rejection-grid',
  templateUrl: './it-facility-rejection-grid.component.html',
  styleUrls: ['./it-facility-rejection-grid.component.scss']
})
export class ItFacilityRejectionGridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }
verifyemployee(id:any){
  this.appservice.ItfacilityReject_editid=id;
  this.router.navigate(['/home/itfacilityrejectionform']);
}
  ngOnInit(): void {
this.appservice.ITfacilityrejectGrid();
  }

}
